import {useContext} from 'react'
import ModalAcceptContext from '@/components/ModalAcceptContext/ModalAcceptContext'

const useAcceptModal = () => useContext(ModalAcceptContext)
export default useAcceptModal
